import { featureFlags } from "@/config/featureFlags";
import DeleteAccountLegacy from "./DeleteAccountLegacy";
import DeleteAccountV2 from "./DeleteAccountV2";

/**
 * Account deletion entry point. The ships-dark flag selects the flow:
 *
 * - OFF (default): the LEGACY flow against `DELETE api/users` (Rust),
 *   byte-for-byte today's behaviour — no capability gap while the new
 *   backend endpoint is dark.
 * - ON: the v2 flow against `DELETE /umbra/v2/users/me` (RFC 9457 ladder,
 *   409 blocked state, full local wipe). See docs/account-deletion.md.
 *
 * Rollback is the config flip, never a revert.
 */
export default function DeleteAccount() {
  return featureFlags.accountDeletionV2 ? (
    <DeleteAccountV2 />
  ) : (
    <DeleteAccountLegacy />
  );
}
